const binder = {
    bindToAll: (event, selector, callback) => {
        document.querySelectorAll(selector).forEach(function (element) {
            element.addEventListener(event, callback);
        });
    },
    executeForAll: (selector, callback) => {
        document.querySelectorAll(selector).forEach(function (element) {
            callback(element);
        });
    }
}

export default binder;